module.exports = __webpack_public_path__ + "media/cica_m.048dd4b9.mp3";